import { network } from 'services/network';

export const createGateTemplate = (params) => {
    return network.post('api/bo/phaseperformance/createGateTemplate', params).then((response) => {
        return response.data;
    });
};
